import { jsx as _jsx } from "react/jsx-runtime";
import { EmailsItem } from "@bluframe/mightychroma-mightytool-ui";
import React from "react";
const Item = ({ errors, isEditing, isSaveLoading, isTemplate, item, onCancel, onEdit, onSave }) => (_jsx(EmailsItem, { errors: errors, isEditing: isEditing, isSaveLoading: isSaveLoading, isTemplate: isTemplate, item: item, onCancel: onCancel, onEdit: onEdit, onSave: onSave }));
export default Item;
